import React from 'react'
import styles from '../css/Gracias.module.css'

export const Gracias = () => {
    return (
        <div className={styles.containerAgradecimiento}>
            <div>
                <p>Gracias por tu compra!</p>
            </div>
        </div>
    )
}
